import * as mutationType from "../mutation_types";

const state = {
  billing: {},
  billing_history: [],
  billing_methods: [],
  billing_trend: [],
  billable_user_count: 0,
  partner_billing: {},
  partner_history: []
};

const getters = {
  billing: state => state.billing,
  billing_history: state => state.billing_history,
  billing_methods: state => state.billing_methods,
  billing_trend: state => state.billing_trend,
  billable_user_count: state => state.billable_user_count,
  partner_billing: state => state.partner_billing,
  partner_history: state => state.partner_history
};

const actions = {
  getBilling({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/billing")
        .then(res => {
          commit(mutationType.SET_BILLING, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBillableUserCount({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/billing/users")
        .then(res => {
          commit(mutationType.SET_BILLABLE_USER_COUNT, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBillingHistory({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/billing/history")
        .then(res => {
          commit(mutationType.SET_BILLING_HISTORY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaymentMethods({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/billing/methods")
        .then(res => {
          commit(mutationType.SET_BILLING_METHODS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getActiveUserTrend({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/billing/trend")
        .then(res => {
          commit(mutationType.SET_BILLING_TREND, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  upgrade({}, request) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/billing/upgrade", request)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  addPaymentMethod({}, billing) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/billing/methods`, billing)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  updatePaymentMethod({}, paymentMethod) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/billing/methods`, paymentMethod)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  updateInvoiceTo({}, billing) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/billing/invoice`, billing)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  setPaymentMethodDefault({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/billing/methods/${id}/default`)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartnerBilling({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/billing/partner`)
        .then(res => {
          commit(mutationType.SET_PARTNER_BILLING, res.data);
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartnerHistory({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/billing/partner/history`, filter)
        .then(res => {
          commit(mutationType.SET_PARTNER_BILLING_HISTORY, res.data);
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_BILLING](state, billing) {
    state.billing = billing;
  },
  [mutationType.SET_BILLING_HISTORY](state, list) {
    state.billing_history = list;
  },
  [mutationType.SET_BILLING_METHODS](state, list) {
    state.billing_methods = list;
  },
  [mutationType.SET_BILLING_TREND](state, list) {
    state.billing_trend = list;
  },
  [mutationType.SET_BILLABLE_USER_COUNT](state, count) {
    state.billable_user_count = count;
  },
  [mutationType.SET_PARTNER_BILLING](state, item) {
    state.partner_billing = item;
  },
  [mutationType.SET_PARTNER_BILLING_HISTORY](state, list) {
    state.partner_history = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
